import { styled } from '@mui/system';

export const CardStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  textAlign: 'left',
  justifyContent: 'center',
  gap: '0.5rem',
  padding: '0.25rem 1rem',
  color: theme.palette.primary.dark,
  backgroundColor: theme.palette.warning.main,
  minHeight: '4rem',
  width: '100%',
}));
